import { exec } from "jadelet"
export default exec(["tool",{"class":[{"bind":"class"},{"bind":"active"}],"click":{"bind":"click"},"title":{"bind":"title"}},[]])